import {Pagination, PaginationParams, SimpleSearchPaginationParams} from "../core/services/utils";
import {http} from "../core/services/http";
import {IAuthor, IBook, INameId} from "../core/interfaces";
import {UUID} from "node:crypto";


export const getAllAuthors = (params?: SimpleSearchPaginationParams) =>
    http.get<Pagination<INameId>>('/api/dashboard/authors', {
        params,
    })

export const getAllAuthorsWithData = (params?: SimpleSearchPaginationParams) =>
    http.get<Pagination<IAuthor>>('/api/dashboard/authors', {
        params,
    })

export const createAuthor = (data: INameId) =>
    http.post<INameId>('/api/dashboard/authors', data)

export const updateAuthor  = (id: UUID, data: INameId) =>
    http.put<INameId>(`/api/dashboard/authors/${id}`,  data )

export const deleteAuthor  = (id: UUID) =>
    http.delete(`/api/dashboard/authors/${id}`, {})